import wrapWithProvider from './wrapWithProvider';

export const wrapRootElement = wrapWithProvider;


export const onInitialClientRender = () => {
  window.scrollTo(0, 0);
};
